import { render, staticRenderFns } from "./InterviewInviteCard.vue?vue&type=template&id=3a8990c6&"
import script from "./InterviewInviteCard.vue?vue&type=script&lang=js&"
export * from "./InterviewInviteCard.vue?vue&type=script&lang=js&"
import style0 from "./InterviewInviteCard.vue?vue&type=style&index=0&id=3a8990c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports